import { call, put, takeLatest, select } from 'redux-saga/effects'
import { types } from '../types/search'
import { ISearchPacksAction } from '../types/search'
import * as actions from '../actions/search'
import * as selectors from '../selectors/search'
import * as services from '../services/search'
import { trace } from '../services/common'

export function* searchPacksSaga(action: ISearchPacksAction) {
  try {
    const query = yield call(services.decorateSearchQuery, action.query)
    const skip = yield select(selectors.selectSkipQuery)
    // TODO: Reset all serach if skip is less that
    // default value of items per page PPP-5006
    if (skip < 20) {
      yield put(actions.resetSearch())
    }
    const { items, totalCount } = yield call(
      services.search,
      services.adaptSearchQuery({ ...query, skip })
    )
    yield put(actions.searchPacksSuccess(items, totalCount))
  } catch (err) {
    trace(err)
    yield put(actions.searchPacksFailure(err.message))
  }
}

export function* searchWatcher() {
  yield takeLatest(types.SEARCH_PACKS__STARTED, searchPacksSaga)
}
